// (function (document, $) {
//
//     $(function () {
//
//         var countryToContinent = {
//             'A1': '--',
//             'A2': '--',
//             'AD': 'EU',
//             'AE': 'AS',
//             'AF': 'AS',
//             'AG': 'NA',
//             'AI': 'NA',
//             'AL': 'EU',
//             'AM': 'AS',
//             'AN': 'NA',
//             'AO': 'AF',
//             'AP': 'AS',
//             'AQ': 'AN',
//             'AR': 'SA',
//             'AS': 'OC',
//             'AT': 'EU',
//             'AU': 'OC',
//             'AW': 'NA',
//             'AX': 'EU',
//             'AZ': 'AS',
//             'BA': 'EU',
//             'BB': 'NA',
//             'BD': 'AS',
//             'BE': 'EU',
//             'BF': 'AF',
//             'BG': 'EU',
//             'BH': 'AS',
//             'BI': 'AF',
//             'BJ': 'AF',
//             'BL': 'NA',
//             'BM': 'NA',
//             'BN': 'AS',
//             'BO': 'SA',
//             'BR': 'SA',
//             'BS': 'NA',
//             'BT': 'AS',
//             'BV': 'AN',
//             'BW': 'AF',
//             'BY': 'EU',
//             'BZ': 'NA',
//             'CA': 'NA',
//             'CC': 'AS',
//             'CD': 'AF',
//             'CF': 'AF',
//             'CG': 'AF',
//             'CH': 'EU',
//             'CI': 'AF',
//             'CK': 'OC',
//             'CL': 'SA',
//             'CM': 'AF',
//             'CN': 'AS',
//             'CO': 'SA',
//             'CR': 'NA',
//             'CU': 'NA',
//             'CV': 'AF',
//             'CX': 'AS',
//             'CY': 'AS',
//             'CZ': 'EU',
//             'DE': 'EU',
//             'DJ': 'AF',
//             'DK': 'EU',
//             'DM': 'NA',
//             'DO': 'NA',
//             'DZ': 'AF',
//             'EC': 'SA',
//             'EE': 'EU',
//             'EG': 'AF',
//             'EH': 'AF',
//             'ER': 'AF',
//             'ES': 'EU',
//             'ET': 'AF',
//             'EU': 'EU',
//             'FI': 'EU',
//             'FJ': 'OC',
//             'FK': 'SA',
//             'FM': 'OC',
//             'FO': 'EU',
//             'FR': 'EU',
//             'FX': 'EU',
//             'GA': 'AF',
//             'GB': 'EU',
//             'GD': 'NA',
//             'GE': 'AS',
//             'GF': 'SA',
//             'GG': 'EU',
//             'GH': 'AF',
//             'GI': 'EU',
//             'GL': 'NA',
//             'GM': 'AF',
//             'GN': 'AF',
//             'GP': 'NA',
//             'GQ': 'AF',
//             'GR': 'EU',
//             'GS': 'AN',
//             'GT': 'NA',
//             'GU': 'OC',
//             'GW': 'AF',
//             'GY': 'SA',
//             'HK': 'AS',
//             'HM': 'AN',
//             'HN': 'NA',
//             'HR': 'EU',
//             'HT': 'NA',
//             'HU': 'EU',
//             'ID': 'AS',
//             'IE': 'EU',
//             'IL': 'AS',
//             'IM': 'EU',
//             'IN': 'AS',
//             'IO': 'AS',
//             'IQ': 'AS',
//             'IR': 'AS',
//             'IS': 'EU',
//             'IT': 'EU',
//             'JE': 'EU',
//             'JM': 'NA',
//             'JO': 'AS',
//             'JP': 'AS',
//             'KE': 'AF',
//             'KG': 'AS',
//             'KH': 'AS',
//             'KI': 'OC',
//             'KM': 'AF',
//             'KN': 'NA',
//             'KP': 'AS',
//             'KR': 'AS',
//             'KW': 'AS',
//             'KY': 'NA',
//             'KZ': 'AS',
//             'LA': 'AS',
//             'LB': 'AS',
//             'LC': 'NA',
//             'LI': 'EU',
//             'LK': 'AS',
//             'LR': 'AF',
//             'LS': 'AF',
//             'LT': 'EU',
//             'LU': 'EU',
//             'LV': 'EU',
//             'LY': 'AF',
//             'MA': 'AF',
//             'MC': 'EU',
//             'MD': 'EU',
//             'ME': 'EU',
//             'MF': 'NA',
//             'MG': 'AF',
//             'MH': 'OC',
//             'MK': 'EU',
//             'ML': 'AF',
//             'MM': 'AS',
//             'MN': 'AS',
//             'MO': 'AS',
//             'MP': 'OC',
//             'MQ': 'NA',
//             'MR': 'AF',
//             'MS': 'NA',
//             'MT': 'EU',
//             'MU': 'AF',
//             'MV': 'AS',
//             'MW': 'AF',
//             'MX': 'NA',
//             'MY': 'AS',
//             'MZ': 'AF',
//             'NA': 'AF',
//             'NC': 'OC',
//             'NE': 'AF',
//             'NF': 'OC',
//             'NG': 'AF',
//             'NI': 'NA',
//             'NL': 'EU',
//             'NO': 'EU',
//             'NP': 'AS',
//             'NR': 'OC',
//             'NU': 'OC',
//             'NZ': 'OC',
//             'O1': '--',
//             'OM': 'AS',
//             'PA': 'NA',
//             'PE': 'SA',
//             'PF': 'OC',
//             'PG': 'OC',
//             'PH': 'AS',
//             'PK': 'AS',
//             'PL': 'EU',
//             'PM': 'NA',
//             'PN': 'OC',
//             'PR': 'NA',
//             'PS': 'AS',
//             'PT': 'EU',
//             'PW': 'OC',
//             'PY': 'SA',
//             'QA': 'AS',
//             'RE': 'AF',
//             'RO': 'EU',
//             'RS': 'EU',
//             'RU': 'EU',
//             'RW': 'AF',
//             'SA': 'AS',
//             'SB': 'OC',
//             'SC': 'AF',
//             'SD': 'AF',
//             'SE': 'EU',
//             'SG': 'AS',
//             'SS': 'AF',
//             'SH': 'AF',
//             'SI': 'EU',
//             'SJ': 'EU',
//             'SK': 'EU',
//             'SL': 'AF',
//             'SM': 'EU',
//             'SN': 'AF',
//             'SO': 'AF',
//             'SR': 'SA',
//             'ST': 'AF',
//             'SV': 'NA',
//             'SY': 'AS',
//             'SZ': 'AF',
//             'TC': 'NA',
//             'TD': 'AF',
//             'TF': 'AN',
//             'TG': 'AF',
//             'TH': 'AS',
//             'TJ': 'AS',
//             'TK': 'OC',
//             'TL': 'AS',
//             'TM': 'AS',
//             'TN': 'AF',
//             'TO': 'OC',
//             'TR': 'EU',
//             'TT': 'NA',
//             'TV': 'OC',
//             'TW': 'AS',
//             'TZ': 'AF',
//             'UA': 'EU',
//             'UG': 'AF',
//             'UM': 'OC',
//             'US': 'NA',
//             'UY': 'SA',
//             'UZ': 'AS',
//             'VA': 'EU',
//             'VC': 'NA',
//             'VE': 'SA',
//             'VG': 'NA',
//             'VI': 'NA',
//             'VN': 'AS',
//             'VU': 'OC',
//             'WF': 'OC',
//             'WS': 'OC',
//             'YE': 'AS',
//             'YT': 'AF',
//             'ZA': 'AF',
//             'ZM': 'AF',
//             'ZW': 'AF'
//         };
//
//         var $mapRoot = $('.interactive-map');
//
//         if ($mapRoot.length > 0) {
//
//             var mode = $mapRoot.data('mode'),
//                 $allPaths = $('svg > path', $mapRoot),
//                 $svg = $('svg', $mapRoot),
//                 ns = $svg.attr('xmlns'),
//                 svg = $svg.get()[0],
//                 point = svg.createSVGPoint(),
//                 previousMouseOverContinent = null;
//
//             // Mark continents in SVG
//             $allPaths.each(function (i, e) {
//                 var $e = $(e),
//                     countryCode = $e.attr('id').toUpperCase(),
//                     continent = countryToContinent[countryCode];
//
//                 if (continent !== undefined && continent !== '--') {
//                     $e.addClass(continent).attr('data-continent', continent);
//                 }
//             });
//            
//             // Hover class over relevant parts of map
//             $('path[data-continent]', $mapRoot).on('mousemove', function (e) {
//                 var $e = $(this),
//                     continent = $e.data('continent');
//
//                 $allPaths.removeClass('hover');
//
//                 if (continent === mode) {
//                     $(this).addClass('hover');
//                 } else if (mode === '') {
//                     $('.' + continent, $mapRoot).addClass('hover');
//                 }
//             }).on('click', function (e) {
//                 var $e = $(this),
//                     continent = $e.data('continent');
//
//                 if ($e.hasClass('active')) {
//                     if (mode === '') {
//                         window.location = '?c=' + continent;
//                     } else if (mode === continent) {
//                         // TODO fetch winehouse list
//                     }
//                 }
//             });
//
//
//             // TODO replace dummy list of nodes with actual call
//             var nodes = [
//                 { country: 'NL', text: 'Test NL', count: 3 },
//                 { country: 'DE', text: 'Test DE', count: 5 },
//                 { country: 'BR', text: 'Test BR', count: 22 },
//                 { country: 'ZA', text: 'Test ZA', count: 4 },
//                 { country: 'FR', text: 'Test FR', count: 5 },
//                 { country: 'SS', text: 'Test SS', count: 8 },
//                 { country: 'IR', text: 'Test IR', count: 1 }
//             ];
//
//             var createMarker = function (x, y, count) {
//                 // Marker
//                 var $marker = $(document.createElementNS(ns, 'g')),
//                     $g = $(document.createElementNS(ns, 'g')),
//                     $path1 = $(document.createElementNS(ns, 'path')),
//                     $path2 = $(document.createElementNS(ns, 'path')),
//                     $ellipse = $(document.createElementNS(ns, 'ellipse')),
//                     $count = $(document.createElementNS(ns, 'text'));
//
//                 $marker.attr('transform', 'translate(' + (x - 10) + ',' + (y - 25) + ') scale(0.7,0.7)').addClass('marker');
//                 $marker.append($g);
//                 $g.append($path1);
//                 $marker.append($path2);
//                 $marker.append($ellipse);
//                 $marker.append($count);
//
//                 $path1.attr('d', 'M16.1,2.5C8.6,2.5,2.5,8.6,2.5,16.1l0,0c0,14.5,13.7,24,13.7,24s13.7-8.4,13.7-24C29.9,8.6,23.7,2.5,16.1,2.5C16.2,2.5,16.2,2.5,16.1,2.5z');
//                 $path2.attr('d', 'M13.7,0C6.1,0,0,6.1,0,13.6l0,0c0,14.5,13.7,24,13.7,24s13.7-8.4,13.7-24C27.4,6.1,21.3,0,13.7,0C13.7,0,13.7,0,13.7,0z');
//                 $ellipse.attr('cx', 13.7).attr('cy', 14.2).attr('rx', 11.1).attr('ry', 11.1);
//                 $count.attr('x', 13).attr('y', 14).attr('dominant-baseline', 'middle').text(count);
//
//                 $svg.append($marker);
//             };
//
//             var handleActiveNode = function (e, c) {
//                 var $e = $(e),
//                     ele = $e.get()[0],
//                     title = $e.attr('title');
//
//                 // Country text
//                 var $text = $(document.createElementNS(ns, 'text')),
//                     rect = ele.getBoundingClientRect();
//
//                 point.x = rect.x;
//                 point.y = rect.y;
//
//                 var topLeft = point.matrixTransform(svg.getScreenCTM().inverse());
//
//                 point.x = rect.right;
//                 point.y = rect.bottom;
//
//                 var bottomRight = point.matrixTransform(svg.getScreenCTM().inverse());
//                 var x = topLeft.x + ((bottomRight.x - topLeft.x) / 2.0);
//                 var y = topLeft.y + ((bottomRight.y - topLeft.y) / 2.0);
//
//                 $text.text(title).attr('x', x).attr('y', y + 7).attr('dominant-baseline', 'middle');
//
//                 $svg.append($text);
//
//                 createMarker(x, y, c.count);
//             };
//
//             // Mark countries as active (or continent, if mode global)
//             $.each(nodes, function (i, e) {
//                 var continent = countryToContinent[e.country];
//
//                 if (mode === '') {
//                     var $nodes = $allPaths.filter('.' + continent).addClass('active'),
//                         minX = null,
//                         maxX = null,
//                         minY = null,
//                         maxY = null,
//                         totalCount = 0;
//
//                     $nodes.each(function (i, e) {
//                         var rect = e.getBoundingClientRect(),
//                             countryCode = $(e).attr('id');
//
//                         if (minX === null || minX > rect.x) {
//                             minX = rect.x;
//                         }
//                         if (maxX === null || maxX < rect.right) {
//                             maxX = rect.right;
//                         }
//
//                         if (minY === null || minY > rect.y) {
//                             minY = rect.y;
//                         }
//                         if (maxY === null || maxY < rect.bottom) {
//                             maxY = rect.bottom;
//                         }
//
//                         $.each(nodes, function (i2, e2) {
//                             if (e2.country === countryCode) {
//                                 totalCount += e2.count;
//                             }
//                         });
//                     });
//
//                     point.x = minX;
//                     point.y = minY;
//
//                     var topLeft = point.matrixTransform(svg.getScreenCTM().inverse());
//
//                     point.x = maxX;
//                     point.y = maxY;
//
//                     var bottomRight = point.matrixTransform(svg.getScreenCTM().inverse());
//                     var x = topLeft.x + ((bottomRight.x - topLeft.x) / 2.0);
//                     var y = topLeft.y + ((bottomRight.y - topLeft.y) / 2.0);
//
//                     createMarker(x, y, totalCount);
//
//                 } else if (mode === continent) {
//                     var $node = $('#' + e.country).addClass('active');
//
//                     handleActiveNode($node, e);
//                 }
//             });
//
//         }
//
//     });
//
// })(document, jQuery);
